<template>
	<div class="markdown prose">
        <p>Alright, here’s the big question: How hands-on do you want to be with your trades?</p>
        <p>Are you ready to channel your inner race car driver—making split-second decisions and chasing adrenaline-fueled opportunities? Or would you rather kick back, relax, and let our Autopilot system handle everything for you?</p>
        <p>Our Autopilot program is powered by three legendary modes inspired by top investors:</p>
        <ul class="ml-8 custom-short-dash-ul">
            <li><span class="text-black01 font-weight-bold">Planetary Mode: </span>Quick, frequent wins—perfect for tactical traders (à la Soros).</li>
            <li><span class="text-black01 font-weight-bold">Stellar Mode: </span>Balanced growth with steady returns (Dalio-style diversification).</li>
            <li><span class="text-black01 font-weight-bold">Galactic Mode: </span>Big, bold moves for long-term success (Buffett-level conviction).</li>
        </ul>
        <p>Autopilot is perfect for building consistency without the stress of constant monitoring. And if you ever want to take the wheel yourself, you can switch to manual trading later.</p>
        <p>So, what’s it going to be?</p>
        <!-- 响应操作 -->
        <ResponseAction @updateResponse="$emit('updateResponse')"></ResponseAction>
        
        
        
        <!-- 发送的消息 -->
        <div id="ai-tradingTypeAnswer" v-if="tradingTypeAnswer != null" class="mt-6 d-flex r-justify-end">
            <v-card rounded="xl" elevation="0" class="pa-4 w-66 text-base" color="f3f3f3-303030">
                <div v-for="(answer, index) in answers" :key="`answer-index-${index}`">
                    <div v-if="answer.code == tradingTypeAnswer">{{ answer.message }}</div>
                </div>
            </v-card>
        </div>
        <!-- 消息框 -->
        <MessageBox v-else :messages="answers" @onSent="setAnswer"></MessageBox>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ResponseAction from "@/views/ai/components/ResponseAction.vue";
import MessageBox from "@/views/ai/components/MessageBox.vue";
export default {
    data(){
        return {
            answers: [
                { code: 'Autopilot', message: 'Autopilot – Effortless Growth' },
                { code: 'Manual', message: 'Race Car Driver – Full Control' }
            ],
        }
    },
    components: { ResponseAction, MessageBox },
    created(){

    },
    mounted(){

    },
    computed: {
        ...mapGetters(['tradingTypeAnswer']),
    },
    watch:{

    },
    methods: {
        setAnswer(data) {
            this.$emit('onSent', data);
        }
    }
}
</script>
<style scoped>

</style>